import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const SettingsAPI = createApi({
    reducerPath: "SettingsAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");

            if (!["SaveFooterContent", "updateFooterContent", "enableGuestChechout", "updateColorTheme", "submitThemeSettingsForm"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        submitThemeSettingsForm: builder.mutation({
            query: (formData) => ({
                url: "admin/color-themes/",
                method: "POST",
                body: formData,
            }),
        }),
        listColorTheme: builder.query({
            query: () => `color-themes`,
        }),
        updateColorTheme: builder.mutation({
            query: ({ id, body  }) => ({
                url: `admin/color-themes/${id}`,
                method: "POST",
                body: body,
            }),
        }),
        SaveFooterContent: builder.mutation({
            query: (formData) => ({
                url: "admin/footer/",
                method: "POST",
                body: formData,
            }),
        }),
        getFooterContent: builder.query({
            query: () => `footer`,
        }),
        updateFooterContent: builder.mutation({
            query: ({formData, id}) => ({
                url: `admin/footer/${id}`,
                method: "POST",
                body: formData,
            }),
        }),
        enableGuestChechout: builder.mutation({
            query: (formData) => ({
                url: `admin/checkout-settings/update`,
                method: "POST",
                body: formData,
            }),
        }),
        displayGuestCheckOUtData: builder.query({
            query: () => `checkout-settings`,
        }),
        getPaymentIcons :builder.query({
            query: () => `payment-gateway-icons`,
        }),
        getCurrencyList: builder.query({
            query: () => `list-currency`,
        }),
        updateCurrency: builder.mutation({
            query: (formData) => ({
                url: `admin/update-currency`,
                method: "PATCH",
                body: formData,
            }),
        }),
    }),
});

export const { useSubmitThemeSettingsFormMutation, useListColorThemeQuery, useUpdateColorThemeMutation ,useSaveFooterContentMutation, useGetFooterContentQuery, useUpdateFooterContentMutation, useEnableGuestChechoutMutation, useDisplayGuestCheckOUtDataQuery,useGetPaymentIconsQuery, useGetCurrencyListQuery , useUpdateCurrencyMutation} = SettingsAPI;
